import React, { useState } from "react";
import { Button, Typography } from "@material-ui/core";
import { Add } from "@material-ui/icons";

export const FileUpload = ({ uploadStatus, setUploadStatus }) => {
    const [filename, setFilename] = useState("");

    // e.target.value retorna: "C://pasta/pasta/ficha.pdf"
    // Essa função remove "C://pasta/pasta/" e retorna somente "ficha.pdf"
    const getFileName = (filename) => {
        //eslint-disable-next-line
        const finalName = filename.replace(/^.*?([^\\\/]*)$/, "$1");
        setFilename(finalName);
    };

    const handleChange = (e) => {
        getFileName(e.target.value);
    };

    return (
        <div>
            <Typography color="textSecondary" gutterBottom>
                Tamanho máximo de arquivo 7mb.
            </Typography>
            <label htmlFor="upload-file-input" style={{ width: "177px" }}>
                <Button startIcon={<Add />} variant="text" color="primary" component="span">
                    Adicionar arquivo
                </Button>
            </label>

            <input
                style={{ display: "none" }}
                accept="application/pdf"
                id="upload-file-input"
                type="file"
                onChange={handleChange}
            />
            <p>{filename}</p>
        </div>
    );
};
